<div>
    <mat-icon matTooltip="{{message}}"  *ngIf="type==='ERROR'" svgIcon="close-circle-outline"></mat-icon>
    <mat-icon matTooltip="{{message}}"  *ngIf="type==='SUCCESS'" svgIcon="check"></mat-icon>
    <mat-icon matTooltip="{{message}}"  *ngIf="type==='PENDING'" svgIcon="sync"></mat-icon>
</div>